import styled, { keyframes } from 'styled-components'

const fadeInOut = keyframes`
    0% {
        opacity: 0.4;
        filter: grayscale(0%);
    }
    50% {
        opacity: 1;
        filter: grayscale(50%);
    }
    100% {
        opacity: 0.4;
        filter: grayscale(0%);
    }
`

export const Container = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: visible;
    animation: ${fadeInOut} 2s ease-in-out infinite;
`
